// Pulled straight from the resume - dates and agency names need to stay
// accurate if this ever gets cross-checked against LinkedIn or a reference.
const experienceList = [
  {
    role: 'Web Developer / Officer',
    org: 'Government of Canada (ESDC)',
    dates: 'Sep 2025 - Present',
    highlights: [
      'Build and maintain pages through an internal CMS, coding updates in JavaScript, HTML, and CSS.',
      'Apply GOC web standards and WCAG accessibility guidelines to every page that goes live.',
      'Handle web design work in the Adobe suite alongside day-to-day front-end maintenance.',
    ],
  },
  {
    role: 'Web Officer / Publisher',
    org: 'Government of Canada (SST)',
    dates: 'Jan 2023 - Jun 2025',
    highlights: [
      'Developed and maintained pages in Drupal, working in JavaScript, HTML, and CSS.',
      'Translated content and design decisions into compliant HTML for public-facing pages.',
      'Followed GOC and WCAG guidelines for all published web media.',
    ],
  },
  {
    role: 'Web Developer / Publisher',
    org: 'Government of Canada (ISED)',
    dates: 'Jun 2023 - Dec 2023',
    highlights: [
      'On-call contract covering Drupal publishing, web design, and front-end development.',
      'Built and processed web forms, including backend submission handling.',
      'Followed federal accessibility guidelines across all web media.',
    ],
  },
];

export default experienceList;
